// @flow
import React from 'react';

//import { searchExact } from 'Api'
import SearchOeuvre from 'Api/Search/oeuvre';

import Layout from 'pages/Avila/ArtWork/List/layout_find'

import SearchModal from './SearchModal';
import type { Props as SearchModalProps } from './SearchModal'

type Props = {
    onClose: any => any,
    actions: Array<any>,
    filterData: Array<any>
}
export default ({
    onClose,
    actions = [],
    filterData = [],
}: Props & SearchModalProps) => {

    return (
        <SearchModal
            title={"Ajouter une oeuvre"} onClose={onClose}
            actions={actions}
            filterData={filterData}
          /*  searchFunction={async query => {

                const oeuvres = await searchExact({
                    type: 'oeuvre',
                    query
                });

                return oeuvres;
            }}*/
            searchFunction={async query => {

                const oeuvres = await SearchOeuvre({ data: {archive : query} })

                return oeuvres.data;
            }}
            renderList={({ data, actions }) => {

                return (
                    <Layout data={data} filterData={filterData} actions={actions} />
                )
            }}
        />
    )
}